<template>
  <div
    :class="['side-bar', {[`zg-border--background-color-${backgroundColor}`]: backgroundColor,}]"
  >
    <h3>
      {{ title }}
    </h3>
    <div class="side-bar--content">
      <zg-product-icon
        product="faq-customer-support"
        size="xxxsmall"
      />
      <div class="items">
        <div
          v-for="(item, index) in sideBarItems"
          :key="index"
        >
          <div class="item-title">
            {{ item.title }}
          </div>

          <div
            v-for="(text, i) in item.data"
            :key="i"
          >
            <zg-side-bar-data
              v-if="text.link"
              :link="text.link"
            />

            <div v-else>
              {{ text.text }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ZgProductIcon from '../ZgProductIcon/ZgProductIcon.vue'
  import ZgSideBarData from './ZgSideBarData.vue'

  export default {
    name: 'ZgSideBar',
    components: {
      ZgSideBarData,
      ZgProductIcon
    },
    props: {
      /**
       * An array with content for the sidebar, it consists of an icon, a sub-title and an array for the data-component.
       */
      sideBarItems: {
        type: Array,
        required: true,
        default: () => []
      },
      /**
       * The main header title for the sidebar.
       */
      title: {
        type: String,
        required: false,
        default: ''
      },
      /**
       *Determines the background-color of the containing div**
       *Is set by using one of the implemented scss-classes:**
       *pink | white | background**
       */
      backgroundColor: {
        type: String,
        default: 'white',
        validator: color => ['white', 'beige'].includes(color)
      }
    }
  }
</script>

<style lang="scss" scoped>
.container {
  padding: rhythm(small);
  border-radius: rhythm(medium);

  @include mq(large) {
    position: sticky;
    top: rhythm();
    max-width: rem(335);
    width: 100%;
    box-sizing: content-box;
    padding: rhythm(base);
  }
}

.zg-border--background-color-beige {
  background-color: color(beige);
}

.zg-border--background-color-white {
  background-color: color(white);
}

.side-bar {
  @include type-body-m;

  border-radius: rhythm(medium);
  margin: 0;
  position: sticky;
  top: rhythm(11);
  padding: rhythm() rhythm() rhythm(medium) rhythm();
  word-break: break-word;
  width: rem(335);

  &--content {
    display: flex;
    align-items: flex-start;
    gap: rhythm(base);
  }

  .items {
    display: flex;
    gap: rhythm(2);
    justify-content: space-between;
    flex-direction: column;

    .item-title {
      @include type-title-s;

      margin: 0;
      margin-bottom: rhythm(.6);
    }
  }

  h3 {
    @include type-title-m;

    border-bottom: 1px solid color(gray-200);
    padding-bottom: rhythm(2);
    margin: 0 0 rhythm(2);
  }

  a {
    color: color(brand-500);
    border-bottom: unset;
  }
}
</style>
